import { render } from "./Conventions.vue?vue&type=template&id=2da14426&scoped=true"
import script from "./Conventions.vue?vue&type=script&lang=js"
export * from "./Conventions.vue?vue&type=script&lang=js"

import "./Conventions.vue?vue&type=style&index=0&id=2da14426&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da14426"]])

export default __exports__